const slider = document.getElementById('slider');

if (slider) {
    const items = document.getElementById('slider-items');
    let slides = Array.from(items.getElementsByClassName('item'));
    let current = 0;

    slide(window.innerWidth > 500 ? 5 : 4);

    setInterval(function() {
        slide(window.innerWidth > 500 ? 5 : 4);
    }, 6000);

    function slide(length = 5) {
        if (slides.length < length) {
            for (let i = 0; i < length; i++) {
                if (slides[current + i]) {
                    slides[current + i].classList.add('inline');
                    slides[current + i].classList.add('visible');
                }
            }
        } else {

            for (let i = 0; i < slides.length; i++) {
                slides[i].classList.remove('inline');
                slides[i].classList.remove('visible');
            }

            current = (current <= slides.length - length) ? current + length : 0;

            if (current >= slides.length) {
                current = 0;
            }

            for (let i = 0; i < length; i++) {
                if (slides[current + i]) {
                    slides[current + i].classList.add('inline');
                    setTimeout(function() {
                        slides[current + i].classList.add('visible');
                    }, 500);
                }
            }
        }
    }
}
